import { useMemo } from "react";
import { useAssetLoader } from "@/components/assets/AssetContext.js";
import { AchievementResources } from "@/components/achievements/AchievementResources.js";


export function useAchievementResources(): AchievementResources {
    const assetLoader = useAssetLoader();
    return useMemo(() => {
        return new AchievementResources(assetLoader);
    }, [assetLoader]);
}
